import React, { useState } from "react";

/**
 * 예약 신청 공통 폼. 회원/비회원 모두 재사용하며, guestFields 가 true 면 예약자명/연락처
 * 입력란을 추가로 보여준다 (비회원은 이 정보로 본인확인을 하기 때문에 필수).
 */
export default function ReservationForm({ storeOptions, guestFields, submitLabel = "예약 신청", onSubmit }) {
  const [storeId, setStoreId] = useState("");
  const [reservationDate, setReservationDate] = useState("");
  const [reservationTime, setReservationTime] = useState("");
  const [partySize, setPartySize] = useState(2);
  const [requestMemo, setRequestMemo] = useState("");
  const [guestName, setGuestName] = useState("");
  const [guestPhone, setGuestPhone] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!storeId || !reservationDate || !reservationTime) {
      setError("매장, 예약일자, 예약시간은 필수입니다.");
      return;
    }
    if (guestFields && (!guestName.trim() || !guestPhone.trim())) {
      setError("예약자명과 연락처를 입력해주세요.");
      return;
    }
    setSubmitting(true);
    try {
      await onSubmit({
        storeId: Number(storeId),
        reservationDate,
        reservationTime,
        partySize: Number(partySize),
        requestMemo,
        ...(guestFields ? { guestName, guestPhone } : {}),
      });
      setStoreId("");
      setReservationDate("");
      setReservationTime("");
      setPartySize(2);
      setRequestMemo("");
      setGuestName("");
      setGuestPhone("");
    } catch (err) {
      setError(err.response?.data?.message || "예약 신청 중 오류가 발생했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="reservation-form" onSubmit={handleSubmit}>
      <label>매장</label>
      <select value={storeId} onChange={(e) => setStoreId(e.target.value)} required>
        <option value="">선택하세요</option>
        {storeOptions.map((s) => <option key={s.storeId} value={s.storeId}>{s.storeName}</option>)}
      </select>

      <div className="reservation-form-row">
        <div>
          <label>예약일자</label>
          <input type="date" value={reservationDate} onChange={(e) => setReservationDate(e.target.value)} required />
        </div>
        <div>
          <label>예약시간</label>
          <input type="time" value={reservationTime} onChange={(e) => setReservationTime(e.target.value)} required />
        </div>
        <div className="party-size-field">
          <label>인원</label>
          <input type="number" min="1" value={partySize} onChange={(e) => setPartySize(e.target.value)} required />
        </div>
      </div>

      {guestFields && (
        <div className="reservation-form-row">
          <div>
            <label>예약자명</label>
            <input value={guestName} onChange={(e) => setGuestName(e.target.value)} required />
          </div>
          <div>
            <label>연락처</label>
            <input value={guestPhone} onChange={(e) => setGuestPhone(e.target.value)} placeholder="010-0000-0000" required />
          </div>
        </div>
      )}

      <label>요청사항 (선택)</label>
      <textarea rows={2} value={requestMemo} onChange={(e) => setRequestMemo(e.target.value)} />

      {error && <p className="error">{error}</p>}

      <button type="submit" disabled={submitting}>{submitting ? "신청 중..." : submitLabel}</button>
    </form>
  );
}
